module.exports = __webpack_public_path__ + "img/grade15.0fe4e064.png";